import { useTranslation } from 'react-i18next';
import { Moon, Sun } from 'lucide-react';

import { toggleTheme, useTheme } from '@/lib/theme';

export default function ThemeToggle() {
  const theme = useTheme();
  const { t } = useTranslation();
  const dark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={toggleTheme}
      title={dark ? t('theme.toLight') : t('theme.toDark')}
      aria-label={dark ? t('theme.toLight') : t('theme.toDark')}
      className="rounded-md p-1 text-faint transition-colors hover:bg-foreground/5 hover:text-foreground"
    >
      {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
